import React from "react";
import SEO from "../components/SEO";
import Footer from "../components/Footer";
import ShiftITLogo from "../images/ShiftITLogo.png";
import {
  Page,
  HeaderBar,
  HeaderInner,
  LogoLink,
  LogoImg,
  Main,
  Article,
  ArticleHeader,
  Title,
  Content,
} from "../components/legal/LegalElements";

export default function SmsTermsPage() {
  return (
    <Page>
      <SEO
        title="SMS Text Messaging Terms | Shift IT"
        description="Read the Shift IT SMS Text Messaging Terms of Use and SMS-specific privacy details for conversational text services."
        canonical="https://shift-it.io/sms-terms"
      />
      <HeaderBar>
        <HeaderInner>
          <LogoLink href="/" aria-label="Go to home">
            <LogoImg src={ShiftITLogo} alt="Shift IT Logo" />
          </LogoLink>
        </HeaderInner>
      </HeaderBar>
      <Main>
        <Article>
          <ArticleHeader>
            <Title>Shift IT Text Messaging Terms of Use</Title>
          </ArticleHeader>
          <Content>
            <p>
              By "Opting In" to or using a Text Message Service (as defined
              below) from Shift IT LLC ("Shift IT," "we," "our," or "us"), you
              accept these Text Messaging Terms of Use ("Terms").
            </p>
            <p>
              This agreement is between you and Shift IT LLC.
              <br />
              Company Address: 915 W Peachtree St NW Unit 15105, Atlanta, GA
              30309
              <br />
              Support Email: support@shift-it.io
            </p>

            <h2>Definitions</h2>
            <p>
              "Opting In," "Opt In," and "Opt-In" mean requesting, joining,
              agreeing to, enrolling in, signing up for, acknowledging,
              responding to, or otherwise consenting to receive one or more text
              messages.
            </p>
            <p>
              "Text Message Service" includes any arrangement in which we send
              one or more messages addressed to your mobile phone number,
              including SMS, MMS, or successor technologies. This service is
              intended for conversational, person-to-person (1:1) communication
              between you and a Shift IT employee.
            </p>

            <h2>Consenting to text messaging</h2>
            <p>
              By consenting to receive text messages from us, you agree to these
              Terms, and our general Terms and Privacy Policy (incorporated by
              reference):
            </p>
            <ul>
              <li>
                Terms:{" "}
                <a href="https://shift-it.io/terms">
                  https://shift-it.io/terms
                </a>
              </li>
              <li>
                Privacy Policy:{" "}
                <a href="https://shift-it.io/privacy">
                  https://shift-it.io/privacy
                </a>
              </li>
            </ul>
            <p>
              <strong>How you opt in (verbal)</strong>: Shift IT collects SMS
              opt-in verbally over the phone or during an onboarding/support
              conversation. You provide your number and we confirm you
              understand message frequency may vary, message/data rates may
              apply, and you can text HELP or STOP.
            </p>
            <p>
              <strong>Verbal opt-in script (used by Shift IT):</strong>
            </p>
            <p>
              "Do you agree to receive conversational text messages from Shift
              IT at this number for support coordination, scheduling, onboarding
              logistics, and service/project communication? Msg frequency
              varies. Msg &amp; data rates may apply. Reply HELP for help. Reply
              STOP to unsubscribe. Privacy Policy: https://shift-it.io/privacy.
              Terms: https://shift-it.io/sms-terms."
            </p>

            <h2>What this service is (and isn&apos;t)</h2>
            <ul>
              <li>
                This is for human-to-human, two-way conversation (support
                coordination, scheduling, onboarding logistics, and
                project/service communications).
              </li>
              <li>
                This is not for marketing promotions, bulk messaging, automated
                alerts, or API-driven messaging.
              </li>
            </ul>

            <h2>E-sign disclosure</h2>
            <p>
              By agreeing to receive text messages, you consent to the use of an
              electronic record to document your agreement. You may withdraw
              your consent at any time by replying STOP.
            </p>

            <h2>SHIFT IT TEXT MESSAGE SERVICE PRIVACY POLICY (SMS-SPECIFIC)</h2>
            <p>
              We respect your privacy. We use information you provide through
              this service only to transmit your mobile messages and respond to
              you. This may include sharing information with platform providers,
              phone carriers, and vendors who assist in delivering mobile
              messages.
            </p>
            <p>
              Mobile information will not be shared with third parties or
              affiliates for marketing or promotional purposes. Text messaging
              originator opt-in data and consent will not be shared with any
              third parties.
            </p>
            <p>
              We may disclose information as necessary to satisfy any law,
              regulation, or governmental request; to avoid liability; or to
              protect our rights or property.
            </p>
            <p>
              This SMS-specific privacy policy applies to your use of the Text
              Message Service and is not intended to modify our general Privacy
              Policy (linked above).
            </p>

            <h2>Costs of text messages</h2>
            <p>
              Shift IT does not charge you for messages you send or receive via
              this service. Message and data rates may apply depending on your
              carrier plan.
            </p>

            <h2>Message frequency</h2>
            <p>
              This is conversational, person-to-person communication. We may
              send an initial message confirming opt-in and service details.
              After that, message frequency varies based on your conversation
              with Shift IT and whether you request help (for example, by
              texting HELP).
            </p>

            <h2>Opting out of text messages</h2>
            <p>
              Reply STOP, QUIT, END, REVOKE, OPT OUT, CANCEL, or UNSUBSCRIBE to
              stop receiving messages from the specific Shift IT number you are
              texting with. We may send a one-time confirmation of your opt-out.
              You may be able to re-subscribe by replying START.
            </p>

            <h2>Help / contact</h2>
            <p>
              Reply HELP or contact{" "}
              <a href="mailto:support@shift-it.io">support@shift-it.io</a>.
            </p>
          </Content>
        </Article>
      </Main>
      <Footer />
    </Page>
  );
}
